document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canAnimate = !prefersReducedMotion && typeof anime !== 'undefined';

  const splitHeadingPreserveAccent = (heading) => {
    if (!heading || heading.dataset.headingAnimated === 'true') return;

    const nodes = Array.from(heading.childNodes);
    const fragment = document.createDocumentFragment();

    const appendText = (value, isAccent = false) => {
      const parts = String(value || '').split(/(\s+)/);

      parts.forEach((part) => {
        if (!part) return;

        const isSpace = /^\s+$/.test(part);
        const span = document.createElement('span');

        span.className = isSpace ? 'heading-written-space' : 'heading-written-word';

        if (isAccent && !isSpace) {
          span.classList.add('is-heading-accent');
        }

        span.textContent = part;
        fragment.appendChild(span);
      });
    };

    nodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        appendText(node.textContent, false);
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const tag = node.tagName.toLowerCase();
        const isAccent = tag === 'em' || tag === 'i' || node.classList.contains('is-heading-accent');

        appendText(node.textContent, isAccent);
      }
    });

    heading.textContent = '';
    heading.appendChild(fragment);
    heading.dataset.headingAnimated = 'true';
  };


  if (mobileToggle && mobileMenu) {
    const setMobileMenuOpen = (isOpen) => {
      mobileMenu.classList.toggle('is-open', isOpen);
      mobileToggle.classList.toggle('is-open', isOpen);
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('themeblocks-mobile-menu-open', isOpen);
    };

    mobileToggle.addEventListener('click', () => {
      setMobileMenuOpen(!mobileMenu.classList.contains('is-open'));
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        setMobileMenuOpen(false);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        setMobileMenuOpen(false);
      }
    });

    document.addEventListener('click', (event) => {
      if (!mobileMenu.classList.contains('is-open')) return;

      const clickedMenu = event.target.closest('[data-mobile-menu]');
      const clickedToggle = event.target.closest('[data-mobile-menu-toggle]');

      if (!clickedMenu && !clickedToggle) {
        setMobileMenuOpen(false);
      }
    });
  }

  const animateHero = () => {
    const hero = document.querySelector('[data-themeblocks-skincare-hero]');
    if (!hero || !canAnimate) return;

    const revealItems = hero.querySelectorAll('[data-hero-reveal]');
    const background = hero.querySelector('[data-hero-bg]');

    if (revealItems.length) {
      anime.set(revealItems, {
        opacity: 0,
        translateY: 22
      });
    }

    if (background) {
      anime.set(background, {
        scale: 1.045,
        translateX: 18
      });
    }

    const timeline = anime.timeline({
      easing: 'easeOutCubic'
    });

    if (background) {
      timeline.add({
        targets: background,
        scale: [1.045, 1],
        translateX: [18, 0],
        duration: 1100
      });
    }

    if (revealItems.length) {
      timeline.add(
        {
          targets: revealItems,
          opacity: [0, 1],
          translateY: [22, 0],
          delay: anime.stagger(110),
          duration: 780
        },
        background ? '-=760' : 0
      );
    }
  };

  const setupWaterRipple = () => {
    const waterSection = document.querySelector('[data-water-effect]');

    if (!waterSection || !canAnimate) return;

    let lastRippleTime = 0;

    const createRipple = (clientX, clientY, isSoft = false) => {
      const now = Date.now();

      if (isSoft && now - lastRippleTime < 160) return;
      lastRippleTime = now;

      const rect = waterSection.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;

      const ripple = document.createElement('span');
      ripple.className = 'hero-themeblocks-skincare__water-ripple';
      ripple.style.setProperty('--ripple-x', `${x}px`);
      ripple.style.setProperty('--ripple-y', `${y}px`);

      waterSection.appendChild(ripple);

      anime({
        targets: ripple,
        opacity: [
          { value: isSoft ? 0.38 : 0.58, duration: 80 },
          { value: 0, duration: isSoft ? 820 : 1100 }
        ],
        scale: [
          { value: 0.25, duration: 0 },
          { value: isSoft ? 7 : 13, duration: isSoft ? 900 : 1250 }
        ],
        easing: 'easeOutSine',
        complete: () => {
          ripple.remove();
        }
      });
    };

    waterSection.addEventListener(
      'pointerdown',
      (event) => {
        createRipple(event.clientX, event.clientY, false);
      },
      { passive: true }
    );

    waterSection.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerType !== 'mouse') return;
        createRipple(event.clientX, event.clientY, true);
      },
      { passive: true }
    );
  };

  const setupSectionAnimations = () => {
    if (!canAnimate) return;

    const sections = document.querySelectorAll('[data-animate-section]');

    if (!sections.length) return;

    sections.forEach((section) => {
      const items = section.querySelectorAll('[data-animate-item]');
      const background = section.querySelector('[data-animate-bg]');
      const sectionType = section.getAttribute('data-animate-section');

      if (items.length) {
        anime.set(items, {
          opacity: 0,
          translateY: sectionType === 'clinical-banner' ? 20 : 18
        });
      }

      if (background) {
        anime.set(background, {
          opacity: 0,
          scale: 1.035
        });
      }
    });

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const section = entry.target;
          const items = section.querySelectorAll('[data-animate-item]');
          const background = section.querySelector('[data-animate-bg]');
          const sectionType = section.getAttribute('data-animate-section');

          const timeline = anime.timeline({
            easing: 'easeOutCubic'
          });

          if (background) {
            timeline.add({
              targets: background,
              opacity: [0, 1],
              scale: [1.035, 1],
              duration: 900
            });
          }

          if (items.length) {
            timeline.add(
              {
                targets: items,
                opacity: [0, 1],
                translateY: [sectionType === 'clinical-banner' ? 20 : 18, 0],
                delay: anime.stagger(sectionType === 'category-strip' ? 80 : 110),
                duration: sectionType === 'category-strip' ? 620 : 740,
                complete: () => {
                  items.forEach((item) => item.style.removeProperty('transform'));
                }
              },
              background ? '-=560' : 0
            );
          }

          section.classList.add('is-animated');
          currentObserver.unobserve(section);
        });
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    sections.forEach((section) => observer.observe(section));
  };

  animateHero();
  setupWaterRipple();
  setupSectionAnimations();
});

/* Final robust product tabs + carousel handler */
(() => {
  const initProductTabs = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((section) => {
      if (section.dataset.productTabsReady === 'true') return;
      section.dataset.productTabsReady = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-product-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-product-panel]'));
      const prev = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');
      const dots = Array.from(section.querySelectorAll('.bestsellers__dot'));

      const getActivePanel = () => section.querySelector('[data-product-panel].is-active');
      const getActiveCarousel = () => {
        const panel = getActivePanel();
        return panel ? panel.querySelector('[data-product-carousel]') : null;
      };

      const updateControls = () => {
        const carousel = getActiveCarousel();
        if (!carousel) return;

        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        const hasOverflow = maxScroll > 8;

        if (prev) prev.disabled = !hasOverflow || carousel.scrollLeft <= 8;
        if (next) next.disabled = !hasOverflow || carousel.scrollLeft >= maxScroll - 8;

        const ratio = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 0;
        const activeDotIndex = ratio > 0.5 ? 1 : 0;

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeDotIndex);
        });

        section.classList.toggle('has-carousel-overflow', hasOverflow);
      };

      // Load + decode the active panel's card images before they are swiped
      // into view; lazy images otherwise load and decode mid-swipe (iOS hitch).
      let isNearViewport = false;

      const warmPanelImages = (panel) => {
        if (!panel || !isNearViewport || panel.dataset.imagesWarmed === 'true') return;
        panel.dataset.imagesWarmed = 'true';

        panel.querySelectorAll('img.cb-bestseller-image--primary').forEach((img) => {
          img.loading = 'eager';
          if (typeof img.decode === 'function') img.decode().catch(() => {});
        });
      };

      if ('IntersectionObserver' in window) {
        const warmObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          isNearViewport = true;
          warmPanelImages(getActivePanel());
          warmObserver.disconnect();
        }, { rootMargin: '600px 0px' });

        warmObserver.observe(section);
      } else {
        isNearViewport = true;
      }

      const activateTab = (target) => {
        tabs.forEach((tab) => {
          const isActive = tab.getAttribute('data-product-tab') === target;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
          const isActive = panel.getAttribute('data-product-panel') === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        const carousel = getActiveCarousel();
        if (carousel) carousel.scrollLeft = 0;

        warmPanelImages(getActivePanel());
        window.requestAnimationFrame(updateControls);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activateTab(tab.getAttribute('data-product-tab'));
        });
      });

      // Snap is disabled on mobile/touch, so step exactly one card there;
      // otherwise keep the page-sized step (snap aligns the result).
      const scrollCarousel = (carousel, direction) => {
        if (getComputedStyle(carousel).scrollSnapType !== 'none') {
          carousel.scrollBy({
            left: direction * Math.round(carousel.clientWidth * 0.9),
            behavior: 'smooth'
          });
          return;
        }

        const cards = Array.from(carousel.children);
        if (!cards.length) return;

        const start = cards[0].offsetLeft;
        const offsets = cards.map((card) => card.offsetLeft - start);
        const current = carousel.scrollLeft;
        const target = direction > 0
          ? offsets.find((offset) => offset > current + 4)
          : offsets.slice().reverse().find((offset) => offset < current - 4);

        carousel.scrollTo({
          left: target === undefined ? (direction > 0 ? carousel.scrollWidth : 0) : target,
          behavior: 'smooth'
        });
      };

      if (prev) {
        prev.addEventListener('click', () => {
          const carousel = getActiveCarousel();
          if (!carousel) return;

          scrollCarousel(carousel, -1);
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          const carousel = getActiveCarousel();
          if (!carousel) return;

          scrollCarousel(carousel, 1);
        });
      }

      panels.forEach((panel) => {
        const carousel = panel.querySelector('[data-product-carousel]');
        if (!carousel) return;

        let controlsFrame = 0;

        carousel.addEventListener('scroll', () => {
          if (controlsFrame) return;

          controlsFrame = window.requestAnimationFrame(() => {
            controlsFrame = 0;
            updateControls();
          });
        }, { passive: true });
      });

      const firstActiveTab = section.querySelector('[data-product-tab].is-active') || tabs[0];
      if (firstActiveTab) {
        activateTab(firstActiveTab.getAttribute('data-product-tab'));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  document.addEventListener('shopify:section:load', initProductTabs);
})();

/* Final carousel controls visibility rule: show only when active panel has more than 4 cards */
(() => {
  const updateBestsellerControlsVisibility = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((section) => {
      const activePanel = section.querySelector('[data-product-panel].is-active');
      const controls = section.querySelector('.bestsellers__controls');

      if (!activePanel || !controls) return;

      const cards = activePanel.querySelectorAll('.bestseller-card');
      const shouldShowControls = cards.length > 4;

      section.classList.toggle('has-more-than-four-products', shouldShowControls);
      controls.hidden = !shouldShowControls;
      controls.setAttribute('aria-hidden', String(!shouldShowControls));
    });
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-product-tab]')) return;

    window.requestAnimationFrame(updateBestsellerControlsVisibility);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBestsellerControlsVisibility);
  } else {
    updateBestsellerControlsVisibility();
  }

  document.addEventListener('shopify:section:load', updateBestsellerControlsVisibility);
})();

/* Bestsellers product reveal animation on tab switch */
(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canAnimate = !prefersReducedMotion && typeof anime !== 'undefined';

  const animateActiveBestsellerCards = (section) => {
    if (!canAnimate || !section) return;

    const activePanel = section.querySelector('[data-product-panel].is-active');
    if (!activePanel) return;

    const cards = activePanel.querySelectorAll('.bestseller-card');
    if (!cards.length) return;

    anime.remove(cards);

    anime.set(cards, {
      opacity: 0,
      translateY: 22,
      scale: 0.985
    });

    anime({
      targets: cards,
      opacity: [0, 1],
      translateY: [22, 0],
      scale: [0.985, 1],
      delay: anime.stagger(85),
      duration: 680,
      easing: 'easeOutCubic',
      complete: () => {
        cards.forEach((card) => card.style.removeProperty('transform'));
      }
    });
  };

  const initBestsellerCardAnimations = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((section) => {
      if (section.dataset.bestsellerCardAnimationReady === 'true') return;
      section.dataset.bestsellerCardAnimationReady = 'true';

      animateActiveBestsellerCards(section);

      section.querySelectorAll('[data-product-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          window.requestAnimationFrame(() => {
            animateActiveBestsellerCards(section);
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestsellerCardAnimations);
  } else {
    initBestsellerCardAnimations();
  }

  document.addEventListener('shopify:section:load', initBestsellerCardAnimations);
})();
/* Shoppable videos carousel */
(() => {
  const initShoppableVideos = () => {
    document.querySelectorAll('[data-shoppable-videos]').forEach((section) => {
      if (section.dataset.shoppableReady === 'true') return;
      section.dataset.shoppableReady = 'true';

      const track = section.querySelector('[data-shoppable-track]');
      const prev = section.querySelector('[data-shoppable-prev]');
      const next = section.querySelector('[data-shoppable-next]');

      if (!track) return;

      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const hasOverflow = maxScroll > 8;

        section.classList.toggle('has-shoppable-overflow', hasOverflow);

        if (prev) prev.disabled = !hasOverflow || track.scrollLeft <= 8;
        if (next) next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 8;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({
            left: -Math.round(track.clientWidth * 0.85),
            behavior: 'smooth'
          });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({
            left: Math.round(track.clientWidth * 0.85),
            behavior: 'smooth'
          });
        });
      }

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShoppableVideos);
  } else {
    initShoppableVideos();
  }

  document.addEventListener('shopify:section:load', initShoppableVideos);
})();

/* Shoppable card video autoplay authority */
(() => {
  const hydrateShoppableCardVideos = (root = document) => {
    const scope = root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-shoppable-videos] .shoppable-video-card__video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');
      video.removeAttribute('controls');

      const playVideo = () => {
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('canplay', playVideo, { once: true });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateShoppableCardVideos());
  } else {
    hydrateShoppableCardVideos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    hydrateShoppableCardVideos(event.target);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) hydrateShoppableCardVideos();
  });
})();


/* Shoppable video modal */
(() => {
  const initShoppableVideoModal = () => {
    const modal = document.querySelector('[data-shoppable-modal]');
    if (!modal || modal.dataset.modalReady === 'true') return;

    modal.dataset.modalReady = 'true';

    const mediaSlot = modal.querySelector('[data-shoppable-modal-media]');
    const titleSlot = modal.querySelector('[data-shoppable-modal-title]');
    const handleSlot = modal.querySelector('[data-shoppable-modal-handle]');
    const cta = modal.querySelector('[data-shoppable-modal-cta]');
    let lastFocused = null;

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('has-shoppable-modal-open');

      if (mediaSlot) {
        mediaSlot.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
        mediaSlot.innerHTML = '';
      }

      if (lastFocused) lastFocused.focus();
    };

    const openModal = (card) => {
      if (!card || !mediaSlot) return;

      lastFocused = document.activeElement;

      const sourceMedia = card.querySelector('.shoppable-video-card__video, .shoppable-video-card__image, .shoppable-video-card__placeholder');
      mediaSlot.innerHTML = '';

      if (sourceMedia) {
        const clonedMedia = sourceMedia.cloneNode(true);

        clonedMedia.classList.remove('shoppable-video-card__video', 'shoppable-video-card__image', 'shoppable-video-card__placeholder');
        clonedMedia.classList.add('shoppable-video-modal__source');

        if (clonedMedia.tagName && clonedMedia.tagName.toLowerCase() === 'video') {
          clonedMedia.controls = true;
          clonedMedia.muted = false;
          clonedMedia.defaultMuted = false;
          clonedMedia.removeAttribute('muted');
          clonedMedia.volume = 1;
          clonedMedia.autoplay = true;
          clonedMedia.loop = true;
          clonedMedia.playsInline = true;
        }

        mediaSlot.appendChild(clonedMedia);

        if (clonedMedia.tagName && clonedMedia.tagName.toLowerCase() === 'video') {
          const playPromise = clonedMedia.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      }

      const title = card.getAttribute('data-title') || '';
      const handle = card.getAttribute('data-handle') || '';
      const productTitle = card.getAttribute('data-product-title') || '';
      const productPrice = card.getAttribute('data-product-price') || '';
      const productImage = card.getAttribute('data-product-image') || '';
      const productUrl = card.getAttribute('data-product-url') || '#';

      if (titleSlot) titleSlot.textContent = title;
      if (handleSlot) handleSlot.textContent = handle;

      if (cta) {
        const ctaImageWrap = cta.querySelector('[data-shoppable-modal-cta-image-wrap]');
        const ctaTitle = cta.querySelector('[data-shoppable-modal-cta-title]');
        const ctaPrice = cta.querySelector('[data-shoppable-modal-cta-price]');

        cta.href = productUrl;

        if (productUrl && productUrl !== '#') {
          cta.hidden = false;
          cta.style.display = 'grid';

          if (ctaImageWrap) {
            if (productImage) {
              ctaImageWrap.innerHTML = `<img src="${productImage}" alt="" class="shoppable-video-modal__cta-image" width="64" height="64">`;
              ctaImageWrap.hidden = false;
            } else {
              ctaImageWrap.innerHTML = '';
              ctaImageWrap.hidden = true;
            }
          }

          if (ctaTitle) {
            ctaTitle.textContent = productTitle || 'Featured product';
          }

          if (ctaPrice) {
            ctaPrice.textContent = productPrice || '';
            ctaPrice.hidden = !productPrice;
          }
        } else {
          cta.hidden = true;
          cta.style.display = 'none';
        }
      }

      modal.hidden = false;
      document.body.classList.add('has-shoppable-modal-open');

      const closeButton = modal.querySelector('[data-shoppable-close]');
      if (closeButton) closeButton.focus();
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-shoppable-open]');
      if (openButton) {
        event.preventDefault();
        const card = openButton.closest('[data-shoppable-card]');
        openModal(card);
        return;
      }

      if (event.target.closest('[data-shoppable-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShoppableVideoModal);
  } else {
    initShoppableVideoModal();
  }

  document.addEventListener('shopify:section:load', initShoppableVideoModal);
})();

/* Editorial written heading animation */
(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canAnimate = !prefersReducedMotion && typeof anime !== 'undefined';

  const headingSelectors = [
    '.hero-themeblocks-skincare__heading',
    '.clinical-banner__heading',
    '.skin-goals__heading',
    '.bestsellers__heading',
    '.why-themeblocks-skincare__heading',
    '.skincare-guide__heading',
    '.shoppable-videos__heading',
    '.newsletter-cta__heading'
  ].join(',');

  const splitHeadingWords = (heading) => {
    if (!heading || heading.dataset.headingSplit === 'true') return;

    const originalText = heading.textContent.trim();
    if (!originalText) return;

    heading.setAttribute('aria-label', originalText);

    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        const fragment = document.createDocumentFragment();
        const parts = text.split(/(\s+)/);

        parts.forEach((part) => {
          if (!part) return;

          if (/^\s+$/.test(part)) {
            const space = document.createElement('span');
            space.className = 'heading-written-space';
            space.textContent = part;
            fragment.appendChild(space);
          } else {
            const word = document.createElement('span');
            word.className = 'heading-written-word';
            word.textContent = part;
            fragment.appendChild(word);
          }
        });

        node.replaceWith(fragment);
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(walk);
      }
    };

    Array.from(heading.childNodes).forEach(walk);

    heading.dataset.headingSplit = 'true';
    heading.dataset.headingWritten = '';
    heading.classList.add('is-heading-prepared');
  };

  const animateHeading = (heading) => {
    if (!canAnimate || !heading || heading.dataset.headingAnimated === 'true') return;

    const words = heading.querySelectorAll('.heading-written-word');
    if (!words.length) return;

    heading.dataset.headingAnimated = 'true';

    anime.remove(words);

    anime.set(words, {
      opacity: 0,
      translateY: 28,
      rotateX: -18,
      filter: 'blur(8px)'
    });

    anime({
      targets: words,
      opacity: [0, 1],
      translateY: [28, 0],
      rotateX: [-18, 0],
      filter: ['blur(8px)', 'blur(0px)'],
      delay: anime.stagger(72),
      duration: 820,
      easing: 'easeOutCubic',
      complete: () => {
        words.forEach((word) => {
          word.style.removeProperty('transform');
          word.style.removeProperty('filter');
        });
      }
    });
  };

  const initWrittenHeadings = () => {
    const headings = document.querySelectorAll(headingSelectors);

    headings.forEach((heading) => {
      splitHeadingWords(heading);
    });

    if (!canAnimate) {
      headings.forEach((heading) => {
        heading.dataset.headingAnimated = 'true';
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        animateHeading(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -8% 0px'
    });

    headings.forEach((heading) => {
      observer.observe(heading);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWrittenHeadings);
  } else {
    initWrittenHeadings();
  }

  document.addEventListener('shopify:section:load', initWrittenHeadings);
})();




/* Product page: quantity and thumbnail switching */
(() => {
  const initProductMain = () => {
    document.querySelectorAll('[data-product-main]').forEach((section) => {
      if (section.dataset.productMainReady === 'true') return;
      section.dataset.productMainReady = 'true';

      const quantityInput = section.querySelector('input[name="quantity"]');
      const minus = section.querySelector('[data-quantity-minus]');
      const plus = section.querySelector('[data-quantity-plus]');

      if (quantityInput && minus) {
        minus.addEventListener('click', () => {
          const current = parseInt(quantityInput.value || '1', 10);
          quantityInput.value = Math.max(1, current - 1);
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (quantityInput && plus) {
        plus.addEventListener('click', () => {
          const current = parseInt(quantityInput.value || '1', 10);
          quantityInput.value = current + 1;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      const mediaFrame = section.querySelector('[data-product-main-media]');
      const thumbs = section.querySelectorAll('[data-product-thumb]');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.getAttribute('data-media-src');
          const type = thumb.getAttribute('data-media-type');

          if (!src || !mediaFrame) return;

          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');

          if (type === 'image') {
            mediaFrame.querySelectorAll('.product-main__image, .product-main__video').forEach((item) => item.remove());

            const image = document.createElement('img');
            image.src = src;
            image.alt = '';
            image.className = 'product-main__image';
            image.loading = 'eager';

            mediaFrame.prepend(image);
          }
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMain);
  } else {
    initProductMain();
  }

  document.addEventListener('shopify:section:load', initProductMain);
})();

/* Product page: tabs */
(() => {
  const initProductTabs = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.productTabsReady === 'true') return;
      tabs.dataset.productTabsReady = 'true';

      const buttons = tabs.querySelectorAll('[data-product-tab-button]');
      const panels = tabs.querySelectorAll('[data-product-tab-panel]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.getAttribute('data-product-tab-button');

          buttons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.getAttribute('data-product-tab-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  document.addEventListener('shopify:section:load', initProductTabs);
})();

/* Product page: tabs */
(() => {
  const initProductTabs = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.productTabsReady === 'true') return;
      tabs.dataset.productTabsReady = 'true';

      const buttons = tabs.querySelectorAll('[data-product-tab-button]');
      const panels = tabs.querySelectorAll('[data-product-tab-panel]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.getAttribute('data-product-tab-button');

          buttons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.getAttribute('data-product-tab-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  document.addEventListener('shopify:section:load', initProductTabs);
})();

/* Product page: related products carousel */
(() => {
  const initRelatedProducts = () => {
    document.querySelectorAll('[data-related-products]').forEach((section) => {
      if (section.dataset.relatedReady === 'true') return;
      section.dataset.relatedReady = 'true';

      const track = section.querySelector('[data-related-track]');
      const prev = section.querySelector('[data-related-prev]');
      const next = section.querySelector('[data-related-next]');

      if (!track) return;

      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const hasOverflow = maxScroll > 8;

        section.classList.toggle('has-related-overflow', hasOverflow);

        if (prev) prev.disabled = !hasOverflow || track.scrollLeft <= 8;
        if (next) next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 8;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({
            left: -Math.round(track.clientWidth * 0.85),
            behavior: 'smooth'
          });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({
            left: Math.round(track.clientWidth * 0.85),
            behavior: 'smooth'
          });
        });
      }

      track.addEventListener('scroll', () => {
        requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProducts);
  } else {
    initRelatedProducts();
  }

  document.addEventListener('shopify:section:load', initRelatedProducts);
})();

/* Product newsletter: loading state + branded snackbar */
(() => {
  const createSnackbar = ({ type = 'success', title = '', text = '' }) => {
    const existing = document.querySelector('.themeblocks-skincare-snackbar');
    if (existing) existing.remove();

    const snackbar = document.createElement('div');
    snackbar.className = `themeblocks-skincare-snackbar themeblocks-skincare-snackbar--${type}`;
    snackbar.setAttribute('role', type === 'error' ? 'alert' : 'status');
    snackbar.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');

    snackbar.innerHTML = `
      <span class="themeblocks-skincare-snackbar__icon" aria-hidden="true">${type === 'error' ? '!' : '✓'}</span>
      <span class="themeblocks-skincare-snackbar__content">
        <strong class="themeblocks-skincare-snackbar__title">${title}</strong>
        <span class="themeblocks-skincare-snackbar__text">${text}</span>
      </span>
      <button class="themeblocks-skincare-snackbar__close" type="button" aria-label="Close notification">×</button>
    `;

    document.body.appendChild(snackbar);

    const close = () => {
      snackbar.classList.remove('is-visible');
      window.setTimeout(() => snackbar.remove(), 260);
    };

    snackbar.querySelector('.themeblocks-skincare-snackbar__close')?.addEventListener('click', close);

    requestAnimationFrame(() => {
      snackbar.classList.add('is-visible');
    });

    window.setTimeout(close, type === 'error' ? 6200 : 4600);
  };

  const initProductNewsletter = () => {
    document.querySelectorAll('.product-newsletter__form').forEach((form) => {
      if (form.dataset.newsletterReady === 'true') return;
      form.dataset.newsletterReady = 'true';

      form.addEventListener('submit', () => {
        form.classList.add('is-submitting');

        const button = form.querySelector('[data-product-newsletter-submit]');
        if (button) {
          button.setAttribute('aria-busy', 'true');
          button.setAttribute('disabled', 'disabled');
        }
      });
    });

    document.querySelectorAll('[data-product-newsletter-message]').forEach((message) => {
      if (message.dataset.toastShown === 'true') return;
      message.dataset.toastShown = 'true';

      const type = message.getAttribute('data-product-newsletter-message');
      const rawText = message.textContent.replace(/\s+/g, ' ').trim();

      if (!rawText) return;

      message.classList.add('is-toast-source');

      createSnackbar({
        type,
        title: type === 'error' ? 'Please check your email' : 'You’re subscribed',
        text: type === 'error' ? rawText : rawText
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductNewsletter);
  } else {
    initProductNewsletter();
  }

  document.addEventListener('shopify:section:load', initProductNewsletter);
})();

/* Product page: thumbnail carousel controls */
(() => {
  const initProductThumbCarousels = () => {
    document.querySelectorAll('[data-product-thumb-carousel]').forEach((carousel) => {
      if (carousel.dataset.thumbCarouselReady === 'true') return;
      carousel.dataset.thumbCarouselReady = 'true';

      const track = carousel.querySelector('[data-product-thumb-track]');
      const prev = carousel.querySelector('[data-product-thumb-prev]');
      const next = carousel.querySelector('[data-product-thumb-next]');

      if (!track) return;

      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const hasOverflow = maxScroll > 8;

        carousel.classList.toggle('has-thumb-overflow', hasOverflow);

        if (prev) prev.disabled = !hasOverflow || track.scrollLeft <= 8;
        if (next) next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 8;
      };

      const scrollAmount = () => {
        const firstThumb = track.querySelector('.product-main__thumb');
        if (!firstThumb) return Math.round(track.clientWidth * 0.75);

        const thumbWidth = firstThumb.getBoundingClientRect().width;
        return Math.round((thumbWidth + 14) * 3);
      };

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({
            left: -scrollAmount(),
            behavior: 'smooth'
          });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({
            left: scrollAmount(),
            behavior: 'smooth'
          });
        });
      }

      track.addEventListener('scroll', () => {
        requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', update, { passive: true });

      update();
      window.setTimeout(update, 250);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductThumbCarousels);
  } else {
    initProductThumbCarousels();
  }

  document.addEventListener('shopify:section:load', initProductThumbCarousels);
})();


/* Product page: quantity controls */
(() => {
  const initProductQuantity = () => {
    document.querySelectorAll('.product-main__quantity').forEach((quantity) => {
      if (quantity.dataset.quantityReady === 'true') return;
      quantity.dataset.quantityReady = 'true';

      const input = quantity.querySelector('input[name="quantity"]');
      const minus = quantity.querySelector('[data-quantity-minus]');
      const plus = quantity.querySelector('[data-quantity-plus]');

      if (!input) return;

      minus?.addEventListener('click', () => {
        const current = Math.max(parseInt(input.value || '1', 10), 1);
        input.value = String(Math.max(current - 1, 1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus?.addEventListener('click', () => {
        const current = Math.max(parseInt(input.value || '1', 10), 1);
        input.value = String(current + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductQuantity);
  } else {
    initProductQuantity();
  }

  document.addEventListener('shopify:section:load', initProductQuantity);
})();

/* FINAL V2: simplified header scroll state controller */
(() => {
  const getThreshold = () => Math.max(window.innerHeight * 0.15, 120);

  const syncThemeBlocksSkincareHeaderState = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const isHome = document.body.classList.contains('template-index');
    const isTransparentHero = header.dataset.transparentHero === 'true';
    const isScrolledEnough = window.scrollY > getThreshold();

    if (isHome && isTransparentHero) {
      header.classList.toggle('is-scrolled', isScrolledEnough);
    } else {
      header.classList.add('is-scrolled');
    }

  };

  const initThemeBlocksSkincareHeaderState = () => {
    syncThemeBlocksSkincareHeaderState();
    requestAnimationFrame(syncThemeBlocksSkincareHeaderState);
    setTimeout(syncThemeBlocksSkincareHeaderState, 150);
    setTimeout(syncThemeBlocksSkincareHeaderState, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeBlocksSkincareHeaderState);
  } else {
    initThemeBlocksSkincareHeaderState();
  }

  window.addEventListener('scroll', syncThemeBlocksSkincareHeaderState, { passive: true });
  window.addEventListener('resize', syncThemeBlocksSkincareHeaderState, { passive: true });
  document.addEventListener('shopify:section:load', initThemeBlocksSkincareHeaderState);
})();

/* Header: hardened Anime.js sticky reveal animation */
(() => {
  const setImportant = (element, property, value) => {
    element.style.setProperty(property, value, 'important');
  };

  const clearAnimatedStyles = (elements) => {
    elements.forEach((element) => {
      element.style.removeProperty('transform');
      element.style.removeProperty('filter');
    });
  };

  const getRevealElements = (header) => {
    const elements = [];

    const logo = header.querySelector('.site-header__logo');
    const navLinks = [...header.querySelectorAll('.site-header__nav-link')];
    const actions = header.querySelector('.site-header__actions');

    if (logo && getComputedStyle(logo).visibility !== 'hidden' && getComputedStyle(logo).opacity !== '0') {
      elements.push(logo);
    }

    navLinks.forEach((link) => elements.push(link));

    if (actions) {
      elements.push(actions);
    }

    return elements;
  };

  const animateStickyHeaderReveal = (header) => {
    if (typeof anime === 'undefined') return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const elements = getRevealElements(header);
    if (!elements.length) return;

    anime.remove(elements);
    anime.remove(header);

    setImportant(header, 'transform', 'translate3d(0, -100%, 0)');
    setImportant(header, 'opacity', '0');

    elements.forEach((element) => {
      setImportant(element, 'transform', 'translate3d(0, -14px, 0)');
      setImportant(element, 'filter', 'blur(7px)');
      setImportant(element, 'opacity', '0');
    });

    const state = { progress: 0 };

    anime({
      targets: state,
      progress: [0, 1],
      duration: 680,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)',
      update: () => {
        const p = state.progress;
        const easedHeaderY = -100 + (100 * p);

        setImportant(header, 'transform', `translate3d(0, ${easedHeaderY}%, 0)`);
        setImportant(header, 'opacity', String(Math.min(1, p * 1.4)));

        elements.forEach((element, index) => {
          const delay = index * 0.075;
          const local = Math.max(0, Math.min(1, (p - delay) / (1 - delay)));
          const y = -14 + (14 * local);
          const blur = 7 - (7 * local);

          setImportant(element, 'transform', `translate3d(0, ${y}px, 0)`);
          setImportant(element, 'filter', `blur(${blur}px)`);
          setImportant(element, 'opacity', String(local));
        });
      },
      complete: () => {
        setImportant(header, 'transform', 'translate3d(0, 0, 0)');
        setImportant(header, 'opacity', '1');

        elements.forEach((element) => {
          setImportant(element, 'transform', 'translate3d(0, 0, 0)');
          setImportant(element, 'filter', 'blur(0px)');
          setImportant(element, 'opacity', '1');
        });

        window.setTimeout(() => {
          clearAnimatedStyles(elements);
          header.style.removeProperty('transform');
        }, 80);
      }
    });
  };

  const initHeaderRevealAnimationV2 = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    if (header.dataset.revealAnimationReady === 'true') return;
    header.dataset.revealAnimationReady = 'true';

    let wasScrolled = header.classList.contains('is-scrolled');

    const check = () => {
      const isScrolled = header.classList.contains('is-scrolled');

      if (isScrolled && !wasScrolled) {
        animateStickyHeaderReveal(header);
      }

      wasScrolled = isScrolled;
    };

    const observer = new MutationObserver(check);

    observer.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('scroll', check, { passive: true });
    document.addEventListener('shopify:section:load', () => {
      header.dataset.revealAnimationReady = 'false';
      initHeaderRevealAnimationV2();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderRevealAnimationV2);
  } else {
    initHeaderRevealAnimationV2();
  }
})();

/* Cart page: Anime.js reveal */
(() => {
  const initCartAnimation = () => {
    const cartPage = document.querySelector('[data-cart-page]');
    if (!cartPage || typeof anime === 'undefined') return;

    if (cartPage.dataset.cartAnimationReady === 'true') return;
    cartPage.dataset.cartAnimationReady = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const header = cartPage.querySelector('.cart-page__header');
    const items = [...cartPage.querySelectorAll('.cart-item')];
    const summary = cartPage.querySelector('.cart-summary-wrap, .cart-summary');
    const empty = cartPage.querySelector('.cart-empty');

    const targets = [header, ...items, summary, empty].filter(Boolean);

    anime.set(targets, {
      opacity: 0,
      translateY: 22,
      filter: 'blur(8px)'
    });

    anime({
      targets,
      opacity: [0, 1],
      translateY: [22, 0],
      filter: ['blur(8px)', 'blur(0px)'],
      delay: anime.stagger(90, { start: 120 }),
      duration: 820,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)',
      complete: () => {
        anime.set(targets, {
          opacity: '',
          translateY: '',
          filter: ''
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartAnimation);
  } else {
    initCartAnimation();
  }

  document.addEventListener('shopify:section:load', initCartAnimation);
})();


/* Cart page AJAX quantity + remove controls */
(() => {
  const formatMoney = (cents, moneyFormat) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const amount = Number(cents || 0) / 100;
    const formatted = amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (moneyFormat && moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', formatted);
    }

    if (moneyFormat && moneyFormat.includes('{{ amount }}')) {
      return moneyFormat.replace('{{ amount }}', formatted);
    }

    return `$${formatted}`;
  };

  const setText = (selector, text) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.textContent = text;
    });
  };

  const updateHeaderCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.setAttribute('aria-label', `${count} item${count === 1 ? '' : 's'} in cart`);
    });
  };

  const setRowLoading = (row, isLoading) => {
    if (!row) return;

    row.classList.toggle('is-loading', isLoading);

    row.querySelectorAll('button, input, a[data-cart-remove]').forEach((element) => {
      if (element.matches('a')) {
        element.setAttribute('aria-disabled', String(isLoading));
      } else {
        element.disabled = isLoading;
      }
    });
  };

  const setRemoveLoading = (removeLink, isLoading) => {
    if (!removeLink) return;

    if (!removeLink.dataset.originalText) {
      removeLink.dataset.originalText = removeLink.textContent.trim();
    }

    removeLink.classList.toggle('is-loading', isLoading);
    removeLink.setAttribute('aria-busy', String(isLoading));
    removeLink.textContent = isLoading ? 'Removing…' : removeLink.dataset.originalText;
  };

  const syncCartDom = (cart, cartPage) => {
    const moneyFormat = cartPage?.dataset.moneyFormat || '${{amount}}';

    updateHeaderCartCount(cart.item_count || 0);

    setText('[data-cart-subtotal]', formatMoney(cart.items_subtotal_price, moneyFormat));
    setText('[data-cart-total]', formatMoney(cart.total_price, moneyFormat));

    const itemMap = new Map((cart.items || []).map((item) => [item.key, item]));

    document.querySelectorAll('[data-cart-item]').forEach((row) => {
      const key = row.dataset.cartItemKey;
      const item = itemMap.get(key);

      if (!item) {
        row.classList.add('is-removing');

        window.setTimeout(() => {
          row.remove();

          const remainingRows = document.querySelectorAll('[data-cart-item]').length;
          if (remainingRows === 0) {
            window.location.reload();
          }
        }, 220);

        return;
      }

      const input = row.querySelector('[data-cart-quantity-input]');
      const lineTotal = row.querySelector('[data-cart-line-total]');

      if (input) {
        input.value = item.quantity;
      }

      if (lineTotal) {
        lineTotal.textContent = formatMoney(item.final_line_price, moneyFormat);
      }
    });
  };

  const changeCartItem = async ({ key, quantity, row, cartPage, removeLink }) => {
    if (!key) return;

    setRowLoading(row, true);
    setRemoveLoading(removeLink, Boolean(removeLink));

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity
        })
      });

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      const cart = await response.json();
      syncCartDom(cart, cartPage);
    } catch (error) {
      console.error('[ThemeBlocks Skincare cart]', error);
      window.location.reload();
    } finally {
      setRowLoading(row, false);
      setRemoveLoading(removeLink, false);
    }
  };

  const initCartAjax = () => {
    const cartPage = document.querySelector('[data-cart-page]');
    if (!cartPage || cartPage.dataset.ajaxCartReady === 'true') return;

    cartPage.dataset.ajaxCartReady = 'true';

    cartPage.addEventListener('click', (event) => {
      const minus = event.target.closest('[data-cart-quantity-minus]');
      const plus = event.target.closest('[data-cart-quantity-plus]');
      const removeLink = event.target.closest('[data-cart-remove]');

      if (!minus && !plus && !removeLink) return;

      const row = event.target.closest('[data-cart-item]');
      if (!row) return;

      const input = row.querySelector('[data-cart-quantity-input]');
      const key = row.dataset.cartItemKey;

      if (removeLink) {
        event.preventDefault();
        changeCartItem({
          key,
          quantity: 0,
          row,
          cartPage,
          removeLink
        });
        return;
      }

      if (!input) return;

      const current = Number(input.value || 0);
      const nextQuantity = plus ? current + 1 : Math.max(0, current - 1);

      input.value = nextQuantity;

      changeCartItem({
        key,
        quantity: nextQuantity,
        row,
        cartPage
      });
    });

    cartPage.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;

      const row = input.closest('[data-cart-item]');
      if (!row) return;

      const quantity = Math.max(0, Number(input.value || 0));

      input.value = quantity;

      changeCartItem({
        key: row.dataset.cartItemKey,
        quantity,
        row,
        cartPage
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartAjax);
  } else {
    initCartAjax();
  }

  document.addEventListener('shopify:section:load', initCartAjax);
})();


/* Global cart behavior setting */
(() => {
  window.ThemeBlocksSkincareCart = window.ThemeBlocksSkincareCart || {};

  window.ThemeBlocksSkincareCart.getAddBehavior = () => {
    return document.body?.dataset?.cartAddBehavior || 'redirect';
  };
})();

/* Global cart behavior setting */
(() => {
  window.ThemeBlocksSkincareCart = window.ThemeBlocksSkincareCart || {};

  window.ThemeBlocksSkincareCart.getAddBehavior = () => {
    return document.body?.dataset?.cartAddBehavior || 'redirect';
  };
})();

/* Cart drawer + AJAX add-to-cart */
(() => {
  const moneyFormat = () => document.querySelector('[data-cart-drawer]')?.dataset.moneyFormat || '${{amount}}';

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat());
    }

    const amount = Number(cents || 0) / 100;
    return `$${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const getBehavior = () => {
    return window.ThemeBlocksSkincareCart?.getAddBehavior?.() || document.body?.dataset?.cartAddBehavior || 'redirect';
  };

  const updateHeaderCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });
  };

  const openDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  };

  const closeDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  };

  const productPrimaryImageCache = new Map();

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const getProductPrimaryImage = async (item) => {
    const fallbackImage = item.featured_image?.url || item.image || '';
    const handle = item.handle;

    if (!handle) return fallbackImage;
    if (productPrimaryImageCache.has(handle)) {
      return productPrimaryImageCache.get(handle) || fallbackImage;
    }

    try {
      const response = await fetch(`/products/${handle}.js`, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        productPrimaryImageCache.set(handle, fallbackImage);
        return fallbackImage;
      }

      const product = await response.json();
      const primaryImage = product?.featured_image || fallbackImage;

      productPrimaryImageCache.set(handle, primaryImage);
      return primaryImage;
    } catch (error) {
      console.error('[ThemeBlocks Skincare cart primary image]', error);
      productPrimaryImageCache.set(handle, fallbackImage);
      return fallbackImage;
    }
  };

  const renderDrawer = async (cart) => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const body = drawer.querySelector('[data-cart-drawer-body]');
    const footer = drawer.querySelector('[data-cart-drawer-footer]');

    updateHeaderCount(cart.item_count || 0);

    if (!body || !footer) return;

    if (!cart.items.length) {
      body.innerHTML = `
        <div class="cart-drawer__empty" data-cart-drawer-empty>
          <div class="cart-drawer__empty-icon" aria-hidden="true">◇</div>
          <h3>Your cart is empty</h3>
          <p>Start building your ThemeBlocks skincare ritual.</p>
          <a href="/collections/all" class="cart-drawer__empty-button">Continue shopping</a>
        </div>
      `;

      footer.innerHTML = '';
      return;
    }

    const cartItems = await Promise.all(cart.items.map(async (item) => {
      return {
        ...item,
        primaryImage: await getProductPrimaryImage(item)
      };
    }));

    body.innerHTML = `
      <div class="cart-drawer__items" data-cart-drawer-items>
        ${cartItems.map((item) => {
          const image = item.primaryImage || item.image || '';
          const title = escapeHtml(item.product_title);
          const variantTitle = item.variant_title ? escapeHtml(item.variant_title) : '';

          return `
            <article class="cart-drawer-item" data-cart-drawer-item data-cart-item-key="${escapeHtml(item.key)}">
              <a href="${escapeHtml(item.url)}" class="cart-drawer-item__media" aria-label="${title}">
                ${image ? `<img src="${escapeHtml(image)}" alt="${title}" class="cart-drawer-item__image" loading="lazy">` : `<span class="cart-drawer-item__placeholder">ThemeBlocks Skincare</span>`}
              </a>

              <div class="cart-drawer-item__content">
                <a href="${escapeHtml(item.url)}" class="cart-drawer-item__title">${title}</a>
                <p class="cart-drawer-item__price">${formatMoney(item.final_price)} each</p>
                ${variantTitle ? `<p class="cart-drawer-item__variant">${variantTitle}</p>` : ''}

                <div class="cart-drawer-item__actions">
                  <div class="cart-drawer-item__quantity" data-cart-drawer-quantity>
                    <button type="button" class="cart-drawer-item__quantity-button" data-cart-drawer-quantity-minus aria-label="Decrease quantity">−</button>
                    <input class="cart-drawer-item__quantity-input" type="number" value="${item.quantity}" min="0" inputmode="numeric" data-cart-drawer-quantity-input>
                    <button type="button" class="cart-drawer-item__quantity-button" data-cart-drawer-quantity-plus aria-label="Increase quantity">+</button>
                  </div>

                  <button type="button" class="cart-drawer-item__remove" data-cart-drawer-remove>Remove</button>
                </div>
              </div>

              <div class="cart-drawer-item__line-total" data-cart-drawer-line-total>
                ${formatMoney(item.final_line_price)}
              </div>
            </article>
          `;
        }).join('')}
      </div>
    `;

    footer.innerHTML = `
      <div class="cart-drawer__subtotal">
        <span>Subtotal</span>
        <strong data-cart-drawer-subtotal>${formatMoney(cart.items_subtotal_price)}</strong>
      </div>

      <p class="cart-drawer__note">Shipping and taxes calculated at checkout.</p>

      <a href="/cart" class="cart-drawer__cart-link">View cart</a>

      <form action="/cart" method="post">
        <button type="submit" name="checkout" class="cart-drawer__checkout">Checkout</button>
      </form>
    `;
  };

  const refreshDrawer = async () => {
    const cart = await getCart();
    renderDrawer(cart);
    return cart;
  };

  const changeCartItem = async (key, quantity, row, removeButton) => {
    if (!key) return;

    row?.classList.add('is-loading');

    if (removeButton) {
      removeButton.classList.add('is-loading');
      removeButton.textContent = 'Removing…';
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!response.ok) {
      window.location.reload();
      return;
    }

    const cart = await response.json();

    if (quantity === 0) {
      row?.classList.add('is-removing');
      setTimeout(() => renderDrawer(cart), 200);
    } else {
      renderDrawer(cart);
    }
  };

  const initDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.drawerReady === 'true') return;

    drawer.dataset.drawerReady = 'true';

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }

      const minus = event.target.closest('[data-cart-drawer-quantity-minus]');
      const plus = event.target.closest('[data-cart-drawer-quantity-plus]');
      const remove = event.target.closest('[data-cart-drawer-remove]');

      if (!minus && !plus && !remove) return;

      const row = event.target.closest('[data-cart-drawer-item]');
      if (!row) return;

      const key = row.dataset.cartItemKey;
      const input = row.querySelector('[data-cart-drawer-quantity-input]');

      if (remove) {
        changeCartItem(key, 0, row, remove);
        return;
      }

      if (!input) return;

      const current = Number(input.value || 0);
      const quantity = plus ? current + 1 : Math.max(0, current - 1);

      input.value = quantity;
      changeCartItem(key, quantity, row);
    });

    drawer.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-drawer-quantity-input]');
      if (!input) return;

      const row = input.closest('[data-cart-drawer-item]');
      if (!row) return;

      const quantity = Math.max(0, Number(input.value || 0));
      input.value = quantity;

      changeCartItem(row.dataset.cartItemKey, quantity, row);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  };

  const initAjaxAddToCart = () => {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      if (getBehavior() !== 'drawer') return;

      event.preventDefault();

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }

      try {
        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });

        if (!response.ok) throw new Error('Add to cart failed');

        await refreshDrawer();
        openDrawer();
      } catch (error) {
        console.error('[ThemeBlocks Skincare cart drawer]', error);
        form.submit();
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initDrawer();
      initAjaxAddToCart();
    });
  } else {
    initDrawer();
    initAjaxAddToCart();
  }

  window.ThemeBlocksSkincareCart = window.ThemeBlocksSkincareCart || {};
  window.ThemeBlocksSkincareCart.openDrawer = openDrawer;
  window.ThemeBlocksSkincareCart.closeDrawer = closeDrawer;
  window.ThemeBlocksSkincareCart.refreshDrawer = refreshDrawer;
})();


/* Cart drawer: Anime.js open polish */
(() => {
  const initCartDrawerAnimation = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.drawerAnimationReady === 'true') return;

    drawer.dataset.drawerAnimationReady = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion || typeof anime === 'undefined') return;

    const panel = drawer.querySelector('.cart-drawer__panel');
    const overlay = drawer.querySelector('.cart-drawer__overlay');

    if (!panel || !overlay) return;

    let wasOpen = drawer.classList.contains('is-open');

    const animateOpen = () => {
      const items = [
        drawer.querySelector('.cart-drawer__header'),
        ...drawer.querySelectorAll('.cart-drawer-item'),
        drawer.querySelector('.cart-drawer__footer')
      ].filter(Boolean);

      anime.remove([panel, overlay, ...items]);

      anime.set(panel, { translateX: '100%' });
      anime.set(overlay, { opacity: 0 });
      anime.set(items, {
        opacity: 0,
        translateY: 14,
        filter: 'blur(6px)'
      });

      anime({
        targets: overlay,
        opacity: [0, 1],
        duration: 280,
        easing: 'easeOutQuad'
      });

      anime({
        targets: panel,
        translateX: ['100%', '0%'],
        duration: 520,
        easing: 'cubicBezier(0.19, 1, 0.22, 1)'
      });

      anime({
        targets: items,
        opacity: [0, 1],
        translateY: [14, 0],
        filter: ['blur(6px)', 'blur(0px)'],
        delay: anime.stagger(55, { start: 160 }),
        duration: 620,
        easing: 'cubicBezier(0.19, 1, 0.22, 1)',
        complete: () => {
          anime.set(items, {
            opacity: '',
            translateY: '',
            filter: ''
          });
        }
      });
    };

    const observer = new MutationObserver(() => {
      const isOpen = drawer.classList.contains('is-open');

      if (isOpen && !wasOpen) {
        animateOpen();
      }

      wasOpen = isOpen;
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerAnimation);
  } else {
    initCartDrawerAnimation();
  }

  document.addEventListener('shopify:section:load', initCartDrawerAnimation);
})();

/* Cart drawer: header cart click behavior */
(() => {
  const getBehavior = () => {
    return window.ThemeBlocksSkincareCart?.getAddBehavior?.() || document.body?.dataset?.cartAddBehavior || 'redirect';
  };

  const initHeaderCartDrawerTrigger = () => {
    document.querySelectorAll('.site-header__cart').forEach((cartLink) => {
      if (cartLink.dataset.drawerTriggerReady === 'true') return;
      cartLink.dataset.drawerTriggerReady = 'true';

      cartLink.addEventListener('click', async (event) => {
        if (getBehavior() !== 'drawer') return;

        event.preventDefault();

        try {
          if (window.ThemeBlocksSkincareCart?.refreshDrawer) {
            await window.ThemeBlocksSkincareCart.refreshDrawer();
          }

          if (window.ThemeBlocksSkincareCart?.openDrawer) {
            window.ThemeBlocksSkincareCart.openDrawer();
          }
        } catch (error) {
          console.error('[ThemeBlocks Skincare cart drawer trigger]', error);
          window.location.href = cartLink.href;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderCartDrawerTrigger);
  } else {
    initHeaderCartDrawerTrigger();
  }

  document.addEventListener('shopify:section:load', initHeaderCartDrawerTrigger);
})();


/* Cart drawer: hardened open/close animation controller */
(() => {
  const getDrawerParts = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return {};

    return {
      drawer,
      panel: drawer.querySelector('.cart-drawer__panel'),
      overlay: drawer.querySelector('.cart-drawer__overlay')
    };
  };

  const resetDrawerInlineStyles = (panel, overlay) => {
    if (panel) {
      panel.style.removeProperty('transform');
      panel.style.removeProperty('opacity');
    }

    if (overlay) {
      overlay.style.removeProperty('opacity');
    }
  };

  const openDrawerAnimated = () => {
    const { drawer, panel, overlay } = getDrawerParts();
    if (!drawer || !panel || !overlay) return;

    drawer.classList.remove('is-closing');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');

    if (typeof anime === 'undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');
      overlay.style.setProperty('opacity', '1', 'important');
      return;
    }

    const revealItems = [
      drawer.querySelector('.cart-drawer__header'),
      ...drawer.querySelectorAll('.cart-drawer-item'),
      drawer.querySelector('.cart-drawer__footer')
    ].filter(Boolean);

    anime.remove([panel, overlay, ...revealItems]);

    anime.set(panel, { translateX: '100%' });
    anime.set(overlay, { opacity: 0 });
    anime.set(revealItems, {
      opacity: 0,
      translateY: 12,
      filter: 'blur(5px)'
    });

    anime({
      targets: overlay,
      opacity: [0, 1],
      duration: 260,
      easing: 'easeOutQuad'
    });

    anime({
      targets: panel,
      translateX: ['100%', '0%'],
      duration: 520,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)'
    });

    anime({
      targets: revealItems,
      opacity: [0, 1],
      translateY: [12, 0],
      filter: ['blur(5px)', 'blur(0px)'],
      delay: anime.stagger(45, { start: 130 }),
      duration: 560,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)',
      complete: () => {
        anime.set(revealItems, {
          opacity: '',
          translateY: '',
          filter: ''
        });
      }
    });
  };

  const closeDrawerAnimated = () => {
    const { drawer, panel, overlay } = getDrawerParts();
    if (!drawer || !panel || !overlay) return;
    if (!drawer.classList.contains('is-open') || drawer.classList.contains('is-closing')) return;

    drawer.classList.add('is-closing');
    drawer.setAttribute('aria-hidden', 'true');

    if (typeof anime === 'undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      drawer.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('cart-drawer-open');
      resetDrawerInlineStyles(panel, overlay);
      return;
    }

    anime.remove([panel, overlay]);

    anime({
      targets: overlay,
      opacity: [1, 0],
      duration: 280,
      easing: 'easeOutQuad'
    });

    anime({
      targets: panel,
      translateX: ['0%', '100%'],
      opacity: [1, 0.98],
      duration: 460,
      easing: 'cubicBezier(0.55, 0, 0.1, 1)',
      complete: () => {
        drawer.classList.remove('is-open', 'is-closing');
        document.body.classList.remove('cart-drawer-open');
        resetDrawerInlineStyles(panel, overlay);
      }
    });
  };

  const initDrawerCloseCapture = () => {
    const { drawer } = getDrawerParts();
    if (!drawer || drawer.dataset.hardenedCloseReady === 'true') return;

    drawer.dataset.hardenedCloseReady = 'true';

    /*
      Capture phase is intentional.
      Older drawer listeners close instantly during bubble phase.
      This prevents them from killing the slide-out animation.
    */
    drawer.addEventListener('click', (event) => {
      const clickedClose = event.target.closest('[data-cart-drawer-close]');
      const clickedInsidePanel = event.target.closest('.cart-drawer__panel');

      if (clickedClose || !clickedInsidePanel) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeDrawerAnimated();
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const { drawer } = getDrawerParts();
      if (!drawer || !drawer.classList.contains('is-open')) return;

      event.preventDefault();
      closeDrawerAnimated();
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerCloseCapture);
  } else {
    initDrawerCloseCapture();
  }

  document.addEventListener('shopify:section:load', initDrawerCloseCapture);

  window.ThemeBlocksSkincareCart = window.ThemeBlocksSkincareCart || {};
  window.ThemeBlocksSkincareCart.openDrawer = openDrawerAnimated;
  window.ThemeBlocksSkincareCart.closeDrawer = closeDrawerAnimated;
})();

/* Collection page: premium product reveal animation */
(() => {
  const initCollectionAnimation = () => {
    const collectionPage = document.querySelector('[data-collection-page]');
    if (!collectionPage || collectionPage.dataset.collectionAnimationReady === 'true') return;

    collectionPage.dataset.collectionAnimationReady = 'true';

    if (typeof anime === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const header = collectionPage.querySelector('[data-collection-animate]');
    const cards = [...collectionPage.querySelectorAll('[data-product-card], [data-collection-animate]')]
      .filter((item) => item !== header);

    const targets = [header, ...cards].filter(Boolean);

    anime.set(targets, {
      opacity: 0,
      translateY: 18,
      filter: 'blur(7px)'
    });

    anime({
      targets,
      opacity: [0, 1],
      translateY: [18, 0],
      filter: ['blur(7px)', 'blur(0px)'],
      delay: anime.stagger(70, { start: 120 }),
      duration: 760,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)',
      complete: () => {
        anime.set(targets, {
          opacity: '',
          translateY: '',
          filter: ''
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAnimation);
  } else {
    initCollectionAnimation();
  }

  document.addEventListener('shopify:section:load', initCollectionAnimation);
})();


/* =========================================================
   HARDENED HERO HEADING ACCENT MARKER
   Marks the final hero heading words as accent after split animation.
   Example: Healthy Skin / Radiant You => Radiant + You become accent.
   ========================================================= */
(() => {
  const markHeroHeadingAccentWords = () => {
    const headings = document.querySelectorAll(
      '[data-themeblocks-skincare-hero] .hero-themeblocks-skincare__heading, .hero-themeblocks-skincare__heading'
    );

    headings.forEach((heading) => {
      const words = Array.from(heading.querySelectorAll('.heading-written-word'));
      if (!words.length) return;

      const accentWordCount = Number(heading.dataset.accentWords || 2);
      const startIndex = Math.max(words.length - accentWordCount, 0);

      words.forEach((word, index) => {
        if (index >= startIndex) {
          word.classList.add('is-heading-accent');
        } else {
          word.classList.remove('is-heading-accent');
        }
      });
    });
  };

  const initHeroHeadingAccentMarker = () => {
    markHeroHeadingAccentWords();

    requestAnimationFrame(markHeroHeadingAccentWords);
    setTimeout(markHeroHeadingAccentWords, 150);
    setTimeout(markHeroHeadingAccentWords, 500);
    setTimeout(markHeroHeadingAccentWords, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroHeadingAccentMarker);
  } else {
    initHeroHeadingAccentMarker();
  }

  document.addEventListener('shopify:section:load', initHeroHeadingAccentMarker);
})();

/* =========================================================
   HARDENED SECTION HEADING ACCENT MARKER
   Applies accent class to final words in editorial split headings.
   ========================================================= */
(() => {
  const markSectionHeadingAccents = () => {
    const headings = document.querySelectorAll([
      '.hero-themeblocks-skincare__heading',
      '.clinical-banner__heading',
      '.clinical__heading',
      '.banner__heading',
      '.image-banner__heading',
      '.skin-goals__heading',
      '.skin-goals__title',
      '[data-clinical-banner] h1',
      '[data-clinical-banner] h2',
      '[data-section-type="clinical-banner"] h1',
      '[data-section-type="clinical-banner"] h2'
    ].join(','));

    headings.forEach((heading) => {
      const words = Array.from(heading.querySelectorAll('.heading-written-word'));
      if (!words.length) return;

      const accentWordCount = Number(heading.dataset.accentWords || 2);
      const startIndex = Math.max(words.length - accentWordCount, 0);

      words.forEach((word, index) => {
        word.classList.toggle('is-heading-accent', index >= startIndex);
      });
    });
  };

  const initSectionHeadingAccents = () => {
    markSectionHeadingAccents();
    requestAnimationFrame(markSectionHeadingAccents);
    setTimeout(markSectionHeadingAccents, 150);
    setTimeout(markSectionHeadingAccents, 500);
    setTimeout(markSectionHeadingAccents, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSectionHeadingAccents);
  } else {
    initSectionHeadingAccents();
  }

  document.addEventListener('shopify:section:load', initSectionHeadingAccents);
})();

/* Skincare sets section animation */
(() => {
  const initSkincareSetsAnimation = () => {
    const section = document.querySelector('[data-animate-section="skincare-sets"]');
    if (!section || section.dataset.skincareSetsAnimated === 'true') return;
    if (typeof anime === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.dataset.skincareSetsAnimated = 'true';

    const items = section.querySelectorAll('[data-animate-item]');

    anime.set(items, {
      opacity: 0,
      translateY: 18,
      filter: 'blur(7px)'
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        anime({
          targets: items,
          opacity: [0, 1],
          translateY: [18, 0],
          filter: ['blur(7px)', 'blur(0px)'],
          delay: anime.stagger(90),
          duration: 760,
          easing: 'cubicBezier(0.19, 1, 0.22, 1)',
          complete: () => {
            items.forEach((item) => {
              item.style.removeProperty('transform');
              item.style.removeProperty('filter');
            });
          }
        });

        observer.disconnect();
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    observer.observe(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkincareSetsAnimation);
  } else {
    initSkincareSetsAnimation();
  }

  document.addEventListener('shopify:section:load', initSkincareSetsAnimation);
})();

/* About ThemeBlocks Skincare page animation */
(() => {
  const initAboutThemeBlocksSkincareAnimation = () => {
    const section = document.querySelector('[data-animate-section="about-themeblocks-skincare"]');
    if (!section || section.dataset.aboutAnimated === 'true') return;
    if (typeof anime === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.dataset.aboutAnimated = 'true';

    const items = section.querySelectorAll('[data-animate-item]');

    anime.set(items, {
      opacity: 0,
      translateY: 20,
      filter: 'blur(8px)'
    });

    anime({
      targets: items,
      opacity: [0, 1],
      translateY: [20, 0],
      filter: ['blur(8px)', 'blur(0px)'],
      delay: anime.stagger(120, { start: 120 }),
      duration: 860,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)'
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutThemeBlocksSkincareAnimation);
  } else {
    initAboutThemeBlocksSkincareAnimation();
  }

  document.addEventListener('shopify:section:load', initAboutThemeBlocksSkincareAnimation);
})();

/* Contact ThemeBlocks Skincare page animation */
(() => {
  const initContactThemeBlocksSkincareAnimation = () => {
    const section = document.querySelector('[data-animate-section="contact-themeblocks-skincare"]');
    if (!section || section.dataset.contactAnimated === 'true') return;
    if (typeof anime === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.dataset.contactAnimated = 'true';

    const items = section.querySelectorAll('[data-animate-item]');

    anime.set(items, {
      opacity: 0,
      translateY: 18,
      filter: 'blur(7px)'
    });

    anime({
      targets: items,
      opacity: [0, 1],
      translateY: [18, 0],
      filter: ['blur(7px)', 'blur(0px)'],
      delay: anime.stagger(110, { start: 120 }),
      duration: 820,
      easing: 'cubicBezier(0.19, 1, 0.22, 1)'
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactThemeBlocksSkincareAnimation);
  } else {
    initContactThemeBlocksSkincareAnimation();
  }

  document.addEventListener('shopify:section:load', initContactThemeBlocksSkincareAnimation);
})();

/* Contact form submit loader */
(() => {
  const initContactFormLoader = () => {
    document.querySelectorAll('.contact-themeblocks-skincare__form').forEach((form) => {
      if (form.dataset.contactLoaderReady === 'true') return;
      form.dataset.contactLoaderReady = 'true';

      const button = form.querySelector('.contact-themeblocks-skincare__button');
      if (!button) return;

      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;

        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactFormLoader);
  } else {
    initContactFormLoader();
  }

  document.addEventListener('shopify:section:load', initContactFormLoader);
})();

/* FAQ ThemeBlocks Skincare accordion + animation */
(() => {
  const initFaqThemeBlocksSkincare = () => {
    document.querySelectorAll('[data-animate-section="faq-themeblocks-skincare"]').forEach((section) => {
      if (section.dataset.faqReady === 'true') return;
      section.dataset.faqReady = 'true';

      const details = section.querySelectorAll('.faq-themeblocks-skincare__item');

      details.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          details.forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });

      if (typeof anime === 'undefined') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const items = section.querySelectorAll('[data-animate-item]');

      anime.set(items, {
        opacity: 0,
        translateY: 18,
        filter: 'blur(7px)'
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          anime({
            targets: items,
            opacity: [0, 1],
            translateY: [18, 0],
            filter: ['blur(7px)', 'blur(0px)'],
            delay: anime.stagger(120),
            duration: 820,
            easing: 'cubicBezier(0.19, 1, 0.22, 1)',
            complete: () => {
              items.forEach((item) => {
                item.style.removeProperty('transform');
                item.style.removeProperty('filter');
              });
            }
          });

          observer.disconnect();
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqThemeBlocksSkincare);
  } else {
    initFaqThemeBlocksSkincare();
  }

  document.addEventListener('shopify:section:load', initFaqThemeBlocksSkincare);
})();

/* LocalStorage wishlist drawer */
(() => {
  const STORAGE_KEY = 'themeblocks-skincare:wishlist';

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  };

  const getProductFromButton = (button) => ({
    handle: button.dataset.wishlistHandle,
    title: button.dataset.wishlistTitle,
    url: button.dataset.wishlistUrl,
    image: button.dataset.wishlistImage,
    price: button.dataset.wishlistPrice,
    variantId: button.dataset.wishlistVariantId
  });

  const isValidProduct = (product) => product && product.handle && product.title && product.url;

  const updateButtons = () => {
    const wishlist = readWishlist();
    const handles = new Set(wishlist.map((item) => item.handle));

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const isActive = handles.has(button.dataset.wishlistHandle);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      const title = button.dataset.wishlistTitle || 'this product';
      button.setAttribute(
        'aria-label',
        isActive ? `Remove ${title} from wishlist` : `Add ${title} to wishlist`
      );

      const text = button.querySelector('span');
      if (text && button.classList.contains('product-main__wishlist')) {
        text.textContent = isActive ? 'Saved' : 'Save';
      }
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      if (wishlist.length === 0) {
        count.textContent = '';
        count.hidden = true;
      } else {
        count.textContent = wishlist.length;
        count.hidden = false;
      }
    });

    document.querySelectorAll('[data-wishlist-open]').forEach((button) => {
      button.classList.toggle('is-active', wishlist.length > 0);
    });
  };

  const renderDrawer = () => {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;

    const wishlist = readWishlist();
    const empty = drawer.querySelector('[data-wishlist-empty]');
    const list = drawer.querySelector('[data-wishlist-items]');

    if (!empty || !list) return;

    empty.hidden = wishlist.length > 0;
    list.hidden = wishlist.length === 0;

    list.innerHTML = wishlist.map((item) => `
      <article class="wishlist-drawer__item" data-wishlist-item="${item.handle}">
        <a href="${item.url}" aria-label="${item.title}">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" class="wishlist-drawer__item-image" loading="lazy">` : `<span class="wishlist-drawer__item-image"></span>`}
        </a>

        <div>
          <a href="${item.url}" class="wishlist-drawer__item-title">${item.title}</a>
          ${item.price ? `<div class="wishlist-drawer__item-price">${item.price}</div>` : ''}
          ${item.variantId ? `<button type="button" class="wishlist-drawer__item-atc" data-wishlist-add-to-cart="${item.variantId}" data-wishlist-add-title="${item.title}">Add to cart</button>` : `<a href="${item.url}" class="wishlist-drawer__item-atc wishlist-drawer__item-atc--link">Choose options</a>`}
        </div>

        <button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove="${item.handle}" aria-label="Remove ${item.title} from wishlist">
          ×
        </button>
      </article>
    `).join('');
  };

  const openDrawer = () => {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;

    renderDrawer();

    drawer.classList.remove('is-closing');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-drawer-open');

    const overlay = drawer.querySelector('.wishlist-drawer__overlay');
    const panel = drawer.querySelector('.wishlist-drawer__panel');

    if (typeof anime !== 'undefined') {
      anime.remove([overlay, panel]);
      anime.set(panel, { translateX: '104%' });
      anime.set(overlay, { opacity: 0 });

      anime({
        targets: overlay,
        opacity: [0, 1],
        duration: 320,
        easing: 'easeOutQuad'
      });

      anime({
        targets: panel,
        translateX: ['104%', '0%'],
        duration: 520,
        easing: 'cubicBezier(0.19, 1, 0.22, 1)'
      });
    } else {
      overlay.style.opacity = '1';
      panel.style.transform = 'translateX(0)';
    }
  };

  const closeDrawer = () => {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;

    const overlay = drawer.querySelector('.wishlist-drawer__overlay');
    const panel = drawer.querySelector('.wishlist-drawer__panel');

    drawer.classList.add('is-closing');

    const finalize = () => {
      drawer.classList.remove('is-open', 'is-closing');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wishlist-drawer-open');
    };

    if (typeof anime !== 'undefined') {
      anime.remove([overlay, panel]);

      anime({
        targets: overlay,
        opacity: [1, 0],
        duration: 260,
        easing: 'easeOutQuad'
      });

      anime({
        targets: panel,
        translateX: ['0%', '104%'],
        duration: 420,
        easing: 'cubicBezier(0.55, 0.08, 0.68, 0.53)',
        complete: finalize
      });
    } else {
      finalize();
    }
  };

  const toggleProduct = (button) => {
    const product = getProductFromButton(button);
    if (!isValidProduct(product)) return;

    const wishlist = readWishlist();
    const exists = wishlist.some((item) => item.handle === product.handle);

    const next = exists
      ? wishlist.filter((item) => item.handle !== product.handle)
      : [product, ...wishlist];

    writeWishlist(next);
    updateButtons();
    renderDrawer();

    if (!exists && typeof anime !== 'undefined') {
      anime({
        targets: button,
        scale: [1, 1.16, 1],
        duration: 360,
        easing: 'easeOutBack'
      });
    }
  };

  const addWishlistItemToCart = async (button) => {
    if (!button || button.disabled) return;

    const variantId = button.dataset.wishlistAddToCart;
    const title = button.dataset.wishlistAddTitle || 'Item';

    if (!variantId) {
      button.textContent = 'Choose options';
      button.classList.add('is-error');
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.classList.remove('is-added', 'is-error');
    button.classList.add('is-loading');
    button.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error(`Could not add ${title} to cart`);
      }

      if (window.ThemeBlocksSkincareCart?.refreshDrawer) {
        await window.ThemeBlocksSkincareCart.refreshDrawer();
      }

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = 'Added';

      if (window.ThemeBlocksSkincareCart?.openDrawer) {
        setTimeout(() => {
          window.ThemeBlocksSkincareCart.openDrawer();
        }, 220);
      }

      setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = originalText;
      }, 1400);
    } catch (error) {
      console.error('[ThemeBlocks Skincare wishlist add]', error);

      button.classList.remove('is-loading');
      button.classList.add('is-error');
      button.textContent = 'Try again';

      setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-error');
        button.textContent = originalText;
      }, 1600);
    }
  };

  const initWishlist = () => {
    updateButtons();
    renderDrawer();

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        toggleProduct(toggle);
        return;
      }

      const open = event.target.closest('[data-wishlist-open]');
      if (open) {
        event.preventDefault();
        openDrawer();
        return;
      }

      const close = event.target.closest('[data-wishlist-close]');
      if (close) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const addToCart = event.target.closest('[data-wishlist-add-to-cart]');
      if (addToCart) {
        addWishlistItemToCart(addToCart);
        return;
      }

      const remove = event.target.closest('[data-wishlist-remove]');
      if (remove) {
        event.preventDefault();
        const handle = remove.dataset.wishlistRemove;
        writeWishlist(readWishlist().filter((item) => item.handle !== handle));
        updateButtons();
        renderDrawer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== STORAGE_KEY) return;
      updateButtons();
      renderDrawer();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }

  document.addEventListener('shopify:section:load', () => {
    updateButtons();
    renderDrawer();
  });

  window.ThemeBlocksSkincareWishlist = {
    open: openDrawer,
    close: closeDrawer,
    read: readWishlist
  };
})();


/* Newsletter CTA AJAX loader + snackbar */
(() => {
  const SNACKBAR_DURATION = 4200;

  const ensureSnackbar = () => {
    let snackbar = document.querySelector('[data-themeblocks-skincare-snackbar]');

    if (snackbar) return snackbar;

    snackbar = document.createElement('div');
    snackbar.className = 'themeblocks-skincare-snackbar';
    snackbar.setAttribute('data-themeblocks-skincare-snackbar', '');
    snackbar.setAttribute('role', 'status');
    snackbar.setAttribute('aria-live', 'polite');
    snackbar.innerHTML = `
      <span class="themeblocks-skincare-snackbar__icon" data-themeblocks-skincare-snackbar-icon>✓</span>
      <p class="themeblocks-skincare-snackbar__message" data-themeblocks-skincare-snackbar-message></p>
    `;

    document.body.appendChild(snackbar);
    return snackbar;
  };

  const showSnackbar = (message, type = 'success') => {
    const snackbar = ensureSnackbar();
    const icon = snackbar.querySelector('[data-themeblocks-skincare-snackbar-icon]');
    const messageNode = snackbar.querySelector('[data-themeblocks-skincare-snackbar-message]');

    snackbar.classList.remove('themeblocks-skincare-snackbar--success', 'themeblocks-skincare-snackbar--error', 'is-visible');
    snackbar.classList.add(`themeblocks-skincare-snackbar--${type}`);

    if (icon) icon.textContent = type === 'error' ? '!' : '✓';
    if (messageNode) messageNode.textContent = message;

    window.clearTimeout(snackbar._themeblocksSkincareTimer);

    requestAnimationFrame(() => {
      snackbar.classList.add('is-visible');
    });

    snackbar._themeblocksSkincareTimer = window.setTimeout(() => {
      snackbar.classList.remove('is-visible');
    }, SNACKBAR_DURATION);
  };

  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  };

  const setSubmitting = (form, isSubmitting) => {
    const submit = form.querySelector('[data-newsletter-cta-submit]');
    const input = form.querySelector('[data-newsletter-cta-input]');

    form.classList.toggle('is-submitting', isSubmitting);

    if (submit) {
      submit.disabled = isSubmitting;
      submit.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }

    if (input) {
      input.disabled = isSubmitting;
    }
  };

  const submitNewsletterAjax = async (form) => {
    const formData = new FormData(form);

    /*
      Shopify customer/contact forms return HTML, not JSON.
      We submit via fetch to avoid reload, then infer success from response.
    */
    const response = await fetch(form.action, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html'
      }
    });

    const html = await response.text();

    if (!response.ok) {
      throw new Error('Newsletter request failed.');
    }

    const lowerHtml = html.toLowerCase();

    /*
      Common Shopify success indicators:
      - customer_posted=true in redirected/fetched URL
      - ContactFooter anchor
      - successful customer form markup in returned HTML
    */
    const looksSuccessful =
      response.url.includes('customer_posted=true') ||
      response.url.includes('#ContactFooter') ||
      lowerHtml.includes('customer_posted=true') ||
      lowerHtml.includes('thank') ||
      lowerHtml.includes('subscrib');

    const looksErrored =
      lowerHtml.includes('form__message') ||
      lowerHtml.includes('errors') ||
      lowerHtml.includes('invalid');

    if (looksErrored && !looksSuccessful) {
      throw new Error('Please check your email and try again.');
    }

    return true;
  };

  const initNewsletterCtaAjax = () => {
    const forms = document.querySelectorAll('[data-newsletter-cta-form]');

    forms.forEach((form) => {
      if (form.dataset.newsletterAjaxReady === 'true') return;
      form.dataset.newsletterAjaxReady = 'true';

      const input = form.querySelector('[data-newsletter-cta-input]');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const email = input?.value || '';

        if (!isValidEmail(email)) {
          setSubmitting(form, false);
          showSnackbar('Please enter a valid email address.', 'error');

          if (input) {
            input.focus();
            input.setAttribute('aria-invalid', 'true');
          }

          return;
        }

        if (input) {
          input.removeAttribute('aria-invalid');
        }

        setSubmitting(form, true);

        try {
          await submitNewsletterAjax(form);

          form.reset();
          showSnackbar('Thank you for subscribing. Welcome to the ThemeBlocks skincare community.', 'success');
        } catch (error) {
          console.error('[ThemeBlocks Skincare newsletter]', error);
          showSnackbar(error.message || 'Something went wrong. Please try again.', 'error');
        } finally {
          setSubmitting(form, false);
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initNewsletterCtaAjax);
  document.addEventListener('shopify:section:load', initNewsletterCtaAjax);
})();

/* Footer accordion desktop/mobile state */
(() => {
  const syncFooterAccordions = () => {
    const accordions = document.querySelectorAll('.site-footer__accordion');
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    accordions.forEach((accordion, index) => {
      if (isDesktop) {
        accordion.open = true;
      } else if (!accordion.dataset.mobileInitialized) {
        accordion.open = index === 0;
        accordion.dataset.mobileInitialized = 'true';
      }
    });
  };

  document.addEventListener('DOMContentLoaded', syncFooterAccordions);
  document.addEventListener('shopify:section:load', syncFooterAccordions);
  window.addEventListener('resize', syncFooterAccordions);
})();

/* Sync wishlist visibility from Header setting */
(() => {
  const syncWishlistVisibilitySetting = () => {
    const header = document.querySelector('[data-site-header]');
    const wishlistEnabled = header?.dataset?.wishlistEnabled !== 'false';

    document.body.classList.toggle('themeblocks-skincare-wishlist-disabled', !wishlistEnabled);
  };

  document.addEventListener('DOMContentLoaded', syncWishlistVisibilitySetting);
  document.addEventListener('shopify:section:load', syncWishlistVisibilitySetting);
})();

/* Header search toggle */
(() => {
  const initHeaderSearch = () => {
    const header = document.querySelector('[data-site-header]');
    const searchPanel = document.querySelector('[data-header-search]');
    const toggles = document.querySelectorAll('[data-search-toggle]');
    const closeButtons = document.querySelectorAll('[data-search-close]');
    const input = document.querySelector('[data-header-search-input]');

    if (!header || !searchPanel || !toggles.length) return;
    if (searchPanel.dataset.searchReady === 'true') return;

    searchPanel.dataset.searchReady = 'true';

    const openSearch = () => {
      searchPanel.hidden = false;

      requestAnimationFrame(() => {
        searchPanel.classList.add('is-open');
        toggles.forEach((toggle) => {
          toggle.setAttribute('aria-expanded', 'true');
        });
      });

      window.setTimeout(() => {
        input?.focus();
      }, 180);
    };

    const closeSearch = () => {
      searchPanel.classList.remove('is-open');
      toggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
      });

      window.setTimeout(() => {
        if (!searchPanel.classList.contains('is-open')) {
          searchPanel.hidden = true;
        }
      }, 220);
    };

    const toggleSearch = () => {
      if (searchPanel.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', toggleSearch);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchPanel.classList.contains('is-open')) {
        closeSearch();
      }
    });

    document.addEventListener('click', (event) => {
      if (!searchPanel.classList.contains('is-open')) return;

      const clickedInsideSearch = event.target.closest('[data-header-search]');
      const clickedToggle = event.target.closest('[data-search-toggle]');

      if (!clickedInsideSearch && !clickedToggle) {
        closeSearch();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initHeaderSearch);
  document.addEventListener('shopify:section:load', initHeaderSearch);
})();


/* AJAX collection/search pagination */
(() => {
  const pageSelectors = [
    {
      page: '.main-collection',
      grid: '.main-collection__grid',
      pagination: '.main-collection__pagination'
    },
    {
      page: '.main-search',
      grid: '.main-search__grid',
      pagination: '.main-search__pagination'
    }
  ];

  const getConfig = (element) => {
    return pageSelectors.find((config) => element?.matches?.(config.page));
  };

  const findPage = (root = document) => {
    return pageSelectors
      .map((config) => root.querySelector(config.page))
      .find(Boolean);
  };

  const syncAjaxAttribute = () => {
    pageSelectors.forEach((config) => {
      document.querySelectorAll(config.page).forEach((page) => {
        page.setAttribute('data-ajax-pagination', '');
      });
    });
  };

  const setLoading = (page, isLoading, link = null) => {
    page.classList.toggle('is-ajax-loading', isLoading);
    page.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (link) {
      link.classList.toggle('is-loading', isLoading);
      link.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
  };

  const replaceElement = (current, next) => {
    if (current && next) {
      current.replaceWith(next);
      return next;
    }

    if (current && !next) {
      current.remove();
      return null;
    }

    return current;
  };

  const refreshPagePieces = async (url, shouldPushState = true, clickedLink = null) => {
    const currentPage = findPage();

    if (!currentPage) return false;

    const config = getConfig(currentPage);

    if (!config) return false;

    setLoading(currentPage, true, clickedLink);

    try {
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Page request failed.');
      }

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextPage = nextDocument.querySelector(config.page);

      if (!nextPage) {
        throw new Error('Updated page markup was not found.');
      }

      const currentGrid = currentPage.querySelector(config.grid);
      const nextGrid = nextPage.querySelector(config.grid);
      const currentPagination = currentPage.querySelector(config.pagination);
      const nextPagination = nextPage.querySelector(config.pagination);

      replaceElement(currentGrid, nextGrid);
      replaceElement(currentPagination, nextPagination);

      if (shouldPushState) {
        window.history.pushState({ themeblocksAjaxPagination: true }, '', url);
      }

      syncAjaxAttribute();

      const refreshedPage = findPage();
      if (refreshedPage) {
        refreshedPage.classList.remove('is-ajax-loading');
        refreshedPage.setAttribute('aria-busy', 'false');

        const headerOffset = document.querySelector('[data-site-header]')?.offsetHeight || 0;
        const targetTop = refreshedPage.getBoundingClientRect().top + window.pageYOffset - headerOffset - 18;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth'
        });
      }

      document.dispatchEvent(new CustomEvent('themeblocks:ajax-pagination:updated', {
        detail: {
          url
        }
      }));

      document.dispatchEvent(new Event('shopify:section:load'));

      return true;
    } catch (error) {
      console.error('[ThemeBlocks AJAX pagination]', error);
      window.location.href = url;
      return false;
    } finally {
      const activePage = findPage();
      if (activePage) {
        setLoading(activePage, false, clickedLink);
      }
    }
  };

  const handlePaginationClick = (event) => {
    const link = event.target.closest('.main-collection__pagination a, .main-search__pagination-link');

    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;

    const url = link.href;

    if (!url || new URL(url, window.location.href).origin !== window.location.origin) return;

    event.preventDefault();
    refreshPagePieces(url, true, link);
  };

  const handlePopState = () => {
    refreshPagePieces(window.location.href, false);
  };

  document.addEventListener('DOMContentLoaded', syncAjaxAttribute);
  document.addEventListener('shopify:section:load', syncAjaxAttribute);
  document.addEventListener('click', handlePaginationClick);
  window.addEventListener('popstate', handlePopState);
})();

/* Header mobile second-level submenu */
(() => {
  const initMobileSubmenus = () => {
    document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
      if (menu.dataset.submenuReady === 'true') return;
      menu.dataset.submenuReady = 'true';

      menu.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const item = toggle.closest('[data-mobile-menu-item]');
          if (!item) return;

          const isOpen = item.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initMobileSubmenus);
  document.addEventListener('shopify:section:load', initMobileSubmenus);
})();


/* Premium collection filters */
(() => {
  const findCollectionPage = () => document.querySelector('[data-collection-page]');

  const setFilterOpen = (isOpen) => {
    const page = findCollectionPage();
    const shell = page?.querySelector('[data-collection-filter-shell]');
    const toggle = page?.querySelector('[data-collection-filter-toggle]');

    if (!shell || !toggle) return;

    shell.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('themeblocks-collection-filter-open', isOpen);
  };

  const replaceCollectionPage = async (url, shouldPushState = true) => {
    const currentPage = findCollectionPage();

    if (!currentPage) return false;

    currentPage.classList.add('is-ajax-loading');
    currentPage.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Collection filter request failed.');
      }

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextPage = nextDocument.querySelector('[data-collection-page]');

      if (!nextPage) {
        throw new Error('Updated collection markup was not found.');
      }

      currentPage.replaceWith(nextPage);

      if (shouldPushState) {
        window.history.pushState({ themeblocksCollectionFilters: true }, '', url);
      }

      document.body.classList.remove('themeblocks-collection-filter-open');
      document.dispatchEvent(new Event('shopify:section:load'));

      const refreshedPage = findCollectionPage();
      const headerOffset = document.querySelector('[data-site-header]')?.offsetHeight || 0;

      if (refreshedPage) {
        refreshedPage.setAttribute('data-ajax-pagination', '');
        refreshedPage.classList.remove('is-ajax-loading');
        refreshedPage.setAttribute('aria-busy', 'false');

        window.scrollTo({
          top: Math.max(refreshedPage.getBoundingClientRect().top + window.pageYOffset - headerOffset - 18, 0),
          behavior: 'smooth'
        });
      }

      return true;
    } catch (error) {
      console.error('[ThemeBlocks collection filters]', error);
      window.location.href = url;
      return false;
    }
  };

  const initCollectionFilters = () => {
    const page = findCollectionPage();

    if (!page || page.dataset.filtersReady === 'true') return;

    page.dataset.filtersReady = 'true';

    page.querySelectorAll('[data-collection-filter-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const shell = page.querySelector('[data-collection-filter-shell]');
        setFilterOpen(!shell?.classList.contains('is-open'));
      });
    });

    page.querySelectorAll('[data-collection-filter-close]').forEach((close) => {
      close.addEventListener('click', () => {
        setFilterOpen(false);
      });
    });

    page.querySelectorAll('[data-collection-filter-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const formData = new FormData(form);
        const params = new URLSearchParams();

        formData.forEach((value, key) => {
          if (value !== '') {
            params.append(key, value);
          }
        });

        const queryString = params.toString();
        const url = queryString ? `${form.action}?${queryString}` : form.action;

        replaceCollectionPage(url, true);
      });
    });

    page.querySelectorAll('[data-collection-filter-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        replaceCollectionPage(link.href, true);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initCollectionFilters);
  document.addEventListener('shopify:section:load', initCollectionFilters);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setFilterOpen(false);
    }
  });
})();

/* PDP expandable product description */
(() => {
  const initProductDescriptions = () => {
    document.querySelectorAll('[data-product-description]').forEach((description) => {
      if (description.dataset.descriptionToggleReady === 'true') return;

      const content = description.querySelector('[data-product-description-content]');
      const toggle = description.querySelector('[data-product-description-toggle]');
      const label = description.querySelector('[data-product-description-toggle-label]');

      if (!content || !toggle || !label) return;

      description.dataset.descriptionToggleReady = 'true';

      const syncToggleVisibility = () => {
        if (description.classList.contains('is-expanded')) return;

        const isOverflowing = content.scrollHeight > content.clientHeight + 2;

        toggle.hidden = !isOverflowing;
      };

      toggle.addEventListener('click', () => {
        const isExpanded = description.classList.toggle('is-expanded');

        toggle.setAttribute('aria-expanded', String(isExpanded));
        label.textContent = isExpanded ? 'Show less' : 'Read more';
      });

      requestAnimationFrame(syncToggleVisibility);

      if (document.fonts?.ready) {
        document.fonts.ready.then(syncToggleVisibility);
      }

      window.addEventListener('resize', syncToggleVisibility, {
        passive: true
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initProductDescriptions);
  document.addEventListener('shopify:section:load', initProductDescriptions);
})();

